import React, { useEffect } from "react";
import ContactSection from "../components/ContactSection/ContactSection"; // Import de la section de contact
import "./ContactPage.css";

const ContactPage = () => {
  useEffect(() => {
    // Définir le titre de la page de contact
    document.title = "AMSEBRID - Location de voitures à Bejaia";
  }, []);

  return (
    <div className="contact-page">
      <ContactSection />
    </div>
  );
};

export default ContactPage;
